import { initializeApp, getApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCY_Xcu5uWxdfcizXW1130McMUGgcInmFI",
  authDomain: "meroghar-app.firebaseapp.com",
  projectId: "meroghar-app",
  storageBucket: "meroghar-app.firebasestorage.app",
  messagingSenderId: "406944796818",
  appId: "1:406944796818:web:da495a83fdff431244964b",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
